"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoolQueryParam = exports.QueryParam = exports.Query = exports.DEFAULT_LIMIT = void 0;
const js_base64_1 = require("js-base64");
exports.DEFAULT_LIMIT = 20;
class Query {
    _queryParams;
    _sort;
    _pager;
    constructor(p) {
        if (p.query && p.query.length > 0) {
            this._queryParams = new Map();
            p.query.forEach((v) => this._queryParams?.set(String(v.name), v));
        }
        if (p.sort && p.sort.length > 0) {
            this._sort = new Map();
            p.sort.forEach((v) => this._sort?.set(v.field, v));
        }
        this._pager = p.pager;
    }
    buildQuery() {
        const q = this._queryParams
            ? `q=${js_base64_1.Base64.encode(JSON.stringify(Object.fromEntries(Array.from(this._queryParams.values()).map((qp) => [
                String(qp.name),
                qp.value,
            ]))))}&`
            : '';
        const s = this._sort
            ? `s=${js_base64_1.Base64.encode(JSON.stringify(Array.from(this._sort.values())))}&`
            : '';
        const p = this._pager
            ? `lim=${this._pager.limit}&offset=${this._pager.offset}`
            : '';
        return `${q}${s}${p}`;
    }
    getParam(key) {
        return this._queryParams?.get(key)?.value;
    }
    addParam(queryParam) {
        this._queryParams?.set(String(queryParam.name), queryParam);
    }
}
exports.Query = Query;
class QueryParam {
    _name;
    _value;
    constructor(name, value) {
        this._name = name;
        this._value = QueryParam.parseParams(value);
    }
    static parseParams(v) {
        if (v instanceof Date) {
            return v.toISOString();
        }
        return v;
    }
    get name() {
        return this._name;
    }
    get value() {
        return this._value;
    }
}
exports.QueryParam = QueryParam;
class BoolQueryParam {
    value;
    constructor(val) {
        this.value = val;
    }
    hasValue() {
        return this.value;
    }
}
exports.BoolQueryParam = BoolQueryParam;
